module.exports = __webpack_public_path__ + "img/firebase.a93cc07a.png";